import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  const linkStyle = { color: '#005CA9', marginRight: '1rem' };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      // Sprawdza, czy użytkownik przewinął do końca strony
      setIsAtBottom(scrollTop + windowHeight >= docHeight - 5); // -5 dla tolerancji
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Strona bez przewijania (np. strona 1 na dużym ekranie) nie wyśle zdarzenia scroll,
    // więc Impressum/Datenschutz nigdy by się nie pokazały. Sprawdzamy też po każdej
    // zmianie wysokości treści. Pierwsze sprawdzenie z opóźnieniem, żeby stopka nie
    // mignęła, zanim dane strony się załadują.
    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(handleScroll) : null;
    const initialCheck = window.setTimeout(() => {
      handleScroll();
      resizeObserver?.observe(document.body);
    }, 500);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      window.clearTimeout(initialCheck);
      resizeObserver?.disconnect();
    };
  }, []);

  return (
    <footer className="footer" style={{ 
      backgroundColor: '#f5f5f5', 
      display: "flex", 
      alignContent:"center", 
      padding: '0.25rem', 
      fontSize: "14px", 
      width: "100%", 
      position: "fixed", 
      bottom: 'env(safe-area-inset-bottom, 0px)', 
      zIndex: 20, 
      opacity: isAtBottom ? 1 : 0, 
      pointerEvents: isAtBottom ? 'auto' : 'none', 
      transition: 'opacity 0.3s ease-out' 
    }}>
      <div className="content">
        <div className="columns is-multiline is-flex is-justify-content-flex-start">
          <div className="column is-full">
            <nav>
              <Link to="https://www.wplusm.de/Imprint" target="_blank" style={linkStyle}>
                Impressum
              </Link>
              <Link to="https://www.wplusm.de/PrivacyDisclaimer" target="_blank" style={linkStyle}>
                Datenschutz
              </Link>
              <Link to="https://wplusm.de/de/kontakt/" target="_blank" style={linkStyle}>
                Kontakt
              </Link>
              <Link to="https://www.wplusm.de/AGB" target="_blank" style={linkStyle}>
                AGB
              </Link>
              <Link to="https://www.wplusm.de/de/widerrufsbelehrung/" target="_blank" style={linkStyle}>
                Widerrufsrecht
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
